// EditorActionBar — Zeile 1 des Editor-Kopfs (Spec Abschnitt 1):
// Physisch-Marker, Deckname (Inline-Rename), Deck-Stats, Playtest/Export rechts.
// Einzeiligkeit und Abbau-Rangfolge liefert ui/ActionBar:
// docs/superpowers/specs/2026-07-27-actionbar-mobile-design.md
import React from 'react';
import ActionBar from '../../../ui/ActionBar';
import Input from '../../../ui/Input';
import { Pencil, Upload, Swords, Lock } from 'lucide-react';
import { formatPrice } from '../utils/formatPrice';

export default function EditorActionBar({
  deckName,
  isPhysical,
  canEditDeck,
  isOwnProfile,
  isEditingDeckName,
  deckNameDraft,
  deckNameInputRef,
  onDeckNameChange,
  onDeckNameBlur,
  onDeckNameKeyDown,
  onOpenDeckNameEditor,
  cardCount,
  totalValue,
  onExport,
  onStartPlaytest,
  playtestLoading,
}) {
  return (
    <ActionBar
      left={
        <>
          {isPhysical && (
            <ActionBar.Marker
              icon={Lock}
              label="Physisch"
              title="Physische Decks sind im Editor weitgehend schreibgeschützt."
            />
          )}
          {canEditDeck && isEditingDeckName ? (
            <ActionBar.Title editing>
              <span className="de-title__input">
                <Input
                  ref={deckNameInputRef}
                  value={deckNameDraft}
                  onChange={(e) => onDeckNameChange(e.target.value)}
                  onBlur={onDeckNameBlur}
                  onKeyDown={onDeckNameKeyDown}
                  aria-label="Deckname bearbeiten"
                  autoFocus
                />
              </span>
            </ActionBar.Title>
          ) : (
            <ActionBar.Title
              action={canEditDeck ? (
                <button
                  type="button"
                  className="de-title__edit"
                  title="Deckname ändern"
                  aria-label="Deckname ändern"
                  onClick={onOpenDeckNameEditor}
                >
                  <Pencil size={15} aria-hidden />
                </button>
              ) : null}
            >
              {deckName || 'Unbenanntes Deck'}
            </ActionBar.Title>
          )}
          {/* Reihenfolge = Wichtigkeit: der Wert überlebt die Kartenzahl, die
              redundant in jedem Kategorie-Zähler steht. */}
          <ActionBar.Stat id="wert">{formatPrice(totalValue)}</ActionBar.Stat>
          <ActionBar.Stat id="karten" value={cardCount} label="Karten" />
        </>
      }
      right={
        <>
          <ActionBar.Action icon={Upload} label="Export" onClick={onExport} />
          {isOwnProfile && (
            <ActionBar.Action
              icon={Swords}
              label={playtestLoading ? 'Startet…' : 'Playtest starten'}
              variant="primary"
              disabled={playtestLoading}
              onClick={onStartPlaytest}
            />
          )}
        </>
      }
    />
  );
}
